module.exports = __webpack_public_path__ + "8e6ad1d4c1deef74b84d56de3b4e1dbf.jpg";